import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { employeesKeys } from 'src/features/employees/api/query-keys/employees';
import { ApiError } from 'src/types/interfaces/api-error';
import { delayedCallbackExecution } from 'src/utils/delayed-callback-execution';
import { assignEmployeesToEmployeeGroup } from '../../lib/employees-group-employees';
import { AssignEmployeesToEmployeeGroupPayload } from '../../types/payload/assign-employees-to-employee-group.payload';

export const useAssignEmployeesToEmployeeGroup = (onSuccess?: () => void) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: AssignEmployeesToEmployeeGroupPayload) =>
      assignEmployeesToEmployeeGroup(payload),
    onSuccess: () => {
      delayedCallbackExecution(1000, () => {
        queryClient.invalidateQueries({
          queryKey: employeesKeys.details(),
        });

        queryClient.invalidateQueries({
          queryKey: employeesKeys.lists(),
        });
      });

      toast.success(
        t('employeesGroups:employees.addEmployeesToGroupDialog.successMessage'),
      );

      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(
        error?.response?.data?.message ||
          t('common:errorMessages:somethingWentWrong'),
      );
    },
  });
};
